export default __webpack_public_path__ + "static/media/newyork.b1dc0f21.jpg";